import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DataCoreService } from '../../services/data-core.service';

@Injectable({
  providedIn: 'root',
})
export class CtGenLookupCokluService {
  constructor(private httpClient: HttpClient,private dataCoreService: DataCoreService) {}
  getDataSource(entityName: string, filterColumn: string, filterName: any, filterSymbol: string) {
    const dataSource = this.dataCoreService.getOData(entityName);
    dataSource.paginate(false);
    dataSource.select([]);
    const filterArr = [];
    if(filterColumn && filterSymbol && filterName) filterArr.push([filterColumn, filterSymbol ,filterName]);
    if(filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
